// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__lLI2m","displayContent":"LandingPage_displayContent__P2qMk"};